import { combineReducers } from 'redux';
import RegistroReducer from './registro-reducer';


const RootReducer = combineReducers({
  registro: RegistroReducer
});

export default RootReducer;
